//@ts-nocheck
import { Node } from 'tiptap'

export default class Image extends Node {
  get name() {
    return 'image'
  }

  get schema() {
    return {
      inline: false,
      attrs: { src: { default: '' }, alt: { default: '' } },
      parseDOM: [{ tag: 'img', getAttrs: dom => ({ src: dom.src, alt: dom.alt }) }],
      toDOM: node => ['img', node.attrs],
    }
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}
